var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('img',{staticStyle:{"padding-bottom":"2vh"},attrs:{"alt":"EPOCH LOGO","src":"http://www.110c.net/yun.png"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }